import { render, staticRenderFns } from "./LivroIcon.vue?vue&type=template&id=ddd9be16&scoped=true"
import script from "./LivroIcon.vue?vue&type=script&lang=js"
export * from "./LivroIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd9be16",
  null
  
)

export default component.exports